import PropTypes from 'prop-types';

// Example of prop-type config setup we can add to be used by other components.  These default types can be appended to
// other prop-type configs as needed.
const config = {
    example: PropTypes.string,
    withRouter: {
        historyPropType: PropTypes.shape({
            push: PropTypes.func.isRequired,
        })
    }
};

export default config;
